import { RouteConfig } from 'vue-router'

const Index2026 = () => import('../activity/sports-618/2026/Index.vue')
const Winners2026 = () => import('../activity/sports-618/2026/Winners.vue')
const SplusRewards2026 = () => import('../activity/sports-618/2026/SplusRewards.vue')
const LotteryRewards2026 = () => import('../activity/sports-618/2026/LotteryRewards.vue')
const StarMaster2026 = () => import('../activity/sports-618/2026/StarMaster.vue')

export const index2026Route: RouteConfig = {
  path: '/activity/sports-618/2026',
  name: 'activity_sports_618_2026',
  component: Index2026,
  redirect: '/activity/sports-618/2026/winners',
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '618星光占星',
  },
}

export const winners2026Route: RouteConfig = {
  path: '/activity/sports-618/2026/winners',
  name: 'activity_sports_618_2026_winners',
  component: Winners2026,
  meta: {
    title: '618星光占星',
  },
}

export const splusRewards2026Route: RouteConfig = {
  path: '/activity/sports-618/2026/splus-rewards',
  name: 'activity_sports_618_2026_splus_rewards',
  component: SplusRewards2026,
  meta: {
    title: '已选奖品记录',
  },
}

export const lotteryRewards2026Route: RouteConfig = {
  path: '/activity/sports-618/2026/lottery-rewards',
  name: 'activity_sports_618_2026_lottery_rewards',
  component: LotteryRewards2026,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export const starMaster2026Route: RouteConfig = {
  path: '/activity/sports-618/2026/star-master',
  name: 'activity_sports_618_2026_star_master',
  component: StarMaster2026,
  meta: {
    title: '每周星主',
  },
}

export default [index2026Route, winners2026Route, splusRewards2026Route, lotteryRewards2026Route, starMaster2026Route]
